module.exports = __webpack_public_path__ + "static/melinda-gates-de26ac91e0fbbdd01a7a0a015d386333.jpg";